import type { Manifest } from "@/features/manifest/model/types";

/** Header / login / title name: product override → dashboard name → org name. */
export function productDisplayName(manifest?: Manifest | null): string {
  const product = manifest?.product_name?.trim();
  if (product) return product;
  const dashboard = manifest?.branding?.dashboard_name?.trim();
  if (dashboard) return dashboard;
  return manifest?.tenant_name?.trim() || "TNN Ops";
}
